import { PlaybackControlsView } from "@src/features/playback/PlaybackControlsView";
import type { Translate } from "@src/i18n/translate";
import { selectCanPlay } from "../state/app-state";
import { useAppStore } from "../hooks/use-app-store";
import { useShallow } from "zustand/react/shallow";

export function PlaybackControls({
  t,
  visualizationReady,
}: {
  t: Translate;
  visualizationReady: boolean;
}) {
  const controller = useAppStore(
    useShallow((state) => ({
      showBasis: state.showBasis,
      showGrid: state.showGrid,
      playbackMode: state.animation.mode,
      playbackStatus: state.animation.status,
      canPlay: selectCanPlay(state),
      onTogglePlayback: state.togglePlayback,
      onResetTransform: state.resetTransform,
      onAnimationModeChange: state.setAnimationMode,
      onBasisVisibilityChange: state.setBasisVisibility,
      onGridVisibilityChange: state.setGridVisibility,
    })),
  );
  return (
    <PlaybackControlsView
      {...controller}
      t={t}
      visualizationReady={visualizationReady}
    />
  );
}
